import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { Box, Dialog, Slide } from "@mui/material";
import DynamicTableProps from "../../Utils/DynamicTableProps";
import AddRole from "./AddRole";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import { deleteItem, fetchAll, fetchById, FetchDataGet } from "../../../BaseUrl";
import { DELETEROLE, GETROLE, GETROLEBYID } from "./Mutation";
import AccessComponent from "../../Utils/AccessComponent";
import MessagePopup from "../../Utils/MessagePopup";
import LoadingSpinner from "../../loader/loadercomp";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Role() {
  const [open, setOpen] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [RoleData, setRoleData] = useState([]);
  const [oneRoleData, setOneRoleData] = useState([]);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [isView, setIsView] = useState(false);
  const [serverPage, setServerPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [prevSearch, setPrevSearch] = useState("");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      let currentPage = serverPage;
      if (searchdata !== prevSearch) {
        setServerPage(1);
        currentPage = 1;
        setPrevSearch(searchdata);
      }
      getRoleData(currentPage, searchdata);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchdata, serverPage]);

  const columns = [
    { label: "Role Name", field: "roleName" },
    { label: "Permissions", field: "permissions" },
    { label: "Status", field: "status" },
    { label: "Actions", field: "actions" },
  ];

  const sortedData = Array.isArray(RoleData) && RoleData.length > 0
      ? [...RoleData]?.sort((a, b) => {
          switch (sortedvalue?.value) {
            case "ascending":
              return new Date(a.createdAt) - new Date(b.createdAt);
            case "descending":
              return new Date(b.createdAt) - new Date(a.createdAt);
            default:
              return RoleData;
          }
        })
      : [];

  const formClose = () => {
    setOpen(false);
    setOneRoleData([]);
    getRoleData(serverPage, searchdata);
    handleCloseDialog();
  };
  const addRole = () => {
    setOpen(true);
  };

  const onView = (id) => {
    setIsView(true);
    setOpen(true);
    getRoleById(id);
  };

  const onEdit = (id) => {
    setIsView(false);
    setOpen(true);
    getRoleById(id);
  };

  const onDelete = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete Role ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteRole(id),
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  //delete api call
  const deleteRole = async (id) => {
    const variables = {
      id: id,
    };
    try {
      const response = await deleteItem(DELETEROLE, { input: variables });
      if (response?.deleteRole?.success === true) {
        setRoleData(response?.deleteRole?.data);
        setPopup({
          open: true,
          message: response?.deleteRole?.message,
          severity: "success",
        });
      } else {
        setPopup({
          open: true,
          message: response?.deleteRole?.message,
          severity: "error",
        });
      }
    } catch (error) {
      setPopup({
        open: true,
        message: error,
        severity: "success",
      });
      console.error(error);
    } finally {
      getRoleData(serverPage, searchdata);
      handleCloseDialog();
    }
  };

  //get api call
  const getRoleData = async (page = serverPage, search = searchdata) => {
    setLoader(true)
    try {
      const variables = {
        search: search,
        page: page,
        pageSize: 10,
      };
      const response = await FetchDataGet(GETROLE, variables);
      if (response?.allRoles?.success === true) {
        setTotalCount(response?.allRoles?.totalCount || 0);
        const data = response?.allRoles?.dataList?.map((v, i) => ({
          id: v?.id || i + 1,
          roleName: v?.roleName,
          status: v?.status === true ? "Active" : "Inactive",
          permissions: v?.permission
            .map((perm) => `${perm.name}: ${perm.access.join(", ")}`)
            .join(" | "),
        }));
      
        setRoleData(data);
      } else {
        setRoleData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false)
    }
  };

  //get by id api call
  const getRoleById = async (id) => {
    const variables = {
      id: id,
    };
    try {
      const response = await fetchById(GETROLEBYID, variables);
      if (response?.getRoleById?.success === true) {
        const data = response?.getRoleById?.data;
        setOneRoleData(Array.isArray(data) ? data : [data]);
      } else {
        setOneRoleData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  return (
    <DashboardLayout searchdata={searchdata} setsearchdata={setsearchdata}>
      {Loader && <LoadingSpinner />}
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        <AccessComponent name="Role Master" action="Create">
          <MaterialButton
            variant="contained"
            onClick={() => {
              addRole();
            }}
            sx={{
              background: colors.buttonColor,
              color: "#fff",
              textTransform: "capitalize",
            }}
          >
            + Add Role
          </MaterialButton>
        </AccessComponent>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
            },
          }}
        >
          <AddRole
            formClose={formClose}
            getRoleData={getRoleData}
            oneRoleData={oneRoleData}
            setPopup={setPopup}
            isView={isView}
            handleOpenDialog={handleOpenDialog}
            setDialogData={setDialogData}
          />
        </Dialog>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={onDelete}
        name="Role Master"
        serverPage={serverPage}
        totalCount={totalCount}
        onPageChange={(event, newPage) => setServerPage(newPage)}
      />
    </DashboardLayout>
  );
}

export default Role;
